<template>
  <div class="stand-turn-page">

    <!-- ========== HEADER ========== -->
    <v-row align="center" class="stand-turn-header px-4">
      <v-col class="stand-turn-header__col">
        <v-icon class="stand-turn-header__back" @click="changePage">mdi-arrow-left</v-icon>
        <span class="stand-turn-header__title">{{ standActions.name || 'Caja' }}</span>
      </v-col>
    </v-row>
    <v-divider />

    <!-- ========== TABS ========== -->
    <v-tabs background-color="#f5f5f5" centered grow height="40px" v-model="activeTab" class="mobile-tabs">
      <v-tab key="0" class="stand-turn-tab">TURNO ACTUAL</v-tab>
      <v-tab key="1" class="stand-turn-tab">COLAS ACTIVAS</v-tab>
    </v-tabs>

    <!-- ========== TAB CONTENT ========== -->
    <v-tabs-items v-model="activeTab" class="stand-turn-tab-content">

      <!-- TAB 0: TURNO ACTUAL -->
      <v-tab-item class="stand-turn-tab-item">
        <div class="turn-panel-wrapper">
          <!-- Project logo -->
          <img
            v-if="projectDetail && projectDetail.logo"
            :src="`data:image/png;base64,${projectDetail.logo}`"
            alt="Logo"
            class="project-logo"
          />
          <div class="turn-panel">

          <!-- Greeting -->
          <p class="turn-greeting">
            Buenos días, estás en la <strong>{{ standActions.name || 'caja' }}</strong>
          </p>

          <!-- Current queue name -->
          <div class="turn-queue-name">
            <p v-if="tiquetQueue && !showbutton" class="turn-queue-name__text">
              Este turno pertenece a la cola de: <strong class="turn-queue-name__highlight">{{ tiquetQueue.nameQueue }}</strong>
            </p>
          </div>

          <!-- Turn number box -->
          <div class="turn-number-box" :class="showbutton ? 'turn-number-box--empty' : 'turn-number-box--active'">
            <p v-if="!showbutton" class="turn-number turn-number--active">
              {{ tiquetNumber }}
            </p>
            <p v-else class="turn-number turn-number--empty">
              --
            </p>
          </div>

          <!-- Badge: Caja abierta -->
          <div class="turn-badge turn-badge--open">
            CAJA ABIERTA
          </div>

          <!-- Badge: Esperando turno -->
          <div v-if="showbutton" class="turn-badge turn-badge--waiting">
            ESPERANDO TURNO
          </div>

          <!-- Action buttons -->
          <div class="turn-actions">

            <!-- New (type 1) -->
            <v-btn v-if="queueType == 1 && !showbutton"
              @click="createTicket" color="#679940" dark depressed x-large block
              class="turn-btn turn-btn--primary">
              <v-icon left>mdi-plus</v-icon>NUEVO
            </v-btn>

            <!-- Previous + Next (type 2) -->
            <div v-if="queueType == 2 && !showbutton" class="turn-actions__row">
              <v-btn @click="deleteTicket" color="#acacac" dark depressed x-large
                class="turn-btn turn-btn--secondary">
                <v-icon left>mdi-skip-previous</v-icon>ANTERIOR
              </v-btn>
              <v-btn @click="createTicket" color="#679940" dark depressed x-large
                class="turn-btn turn-btn--secondary">
                <v-icon left>mdi-skip-next</v-icon>SIGUIENTE
              </v-btn>
            </div>

            <!-- Finish and next -->
            <v-btn v-if="showCreate == false && !showbutton"
              @click="closeAndNextTicket" outlined color="#679940" x-large block
              class="turn-btn turn-btn--outlined-green">
              <v-icon left size="22" color="#679940">mdi-close-circle</v-icon>
              FINALIZAR Y SIGUIENTE
            </v-btn>

            <!-- Cancel and next -->
            <v-btn v-if="showCreate == false && !showbutton"
              @click="cancelAndNextTicket" outlined color="#999" x-large block
              class="turn-btn turn-btn--outlined-gray">
              <v-icon left size="22" color="#999">mdi-cancel</v-icon>
              CANCELAR Y SIGUIENTE
            </v-btn>

          </div>
          </div>
        </div>
      </v-tab-item>

      <!-- TAB 1: COLAS ACTIVAS -->
      <v-tab-item class="queue-tab-item">
        <!-- Empty state -->
        <div v-if="tiquets.length === 0" class="queue-empty">
          <v-icon size="48" color="#ccc">mdi-playlist-remove</v-icon>
          <p class="queue-empty__text">No hay colas activas.</p>
        </div>

        <!-- Queue cards -->
        <div v-for="queue in tiquets" :key="queue.queue" :id="queue.queue"
          class="queue-card" :class="queue.switch !== false ? 'queue-card--active' : 'queue-card--inactive'">
          <div class="queue-card__row">
            <!-- Icon -->
            <div class="queue-card__icon">
              <v-icon v-if="queue.typeQueue == 1" :color="queue.switch !== false ? '#679940' : '#999'" size="24">mdi-human-male-male</v-icon>
              <v-icon v-if="queue.typeQueue == 2" :color="queue.switch !== false ? '#679940' : '#999'" size="24">mdi-ticket-outline</v-icon>
              <v-icon v-if="queue.typeQueue == 3" :color="queue.switch !== false ? '#679940' : '#999'" size="24">mdi-ticket-confirmation</v-icon>
            </div>
            <!-- Info -->
            <div class="queue-card__info">
              <p class="queue-card__name" :class="queue.switch !== false ? 'queue-card__name--active' : 'queue-card__name--inactive'">{{ queue.nameQueue }}</p>
              <p class="queue-card__detail">Personas esperando: <strong :class="queue.switch !== false ? 'text-green' : 'text-gray'">{{ queue.pending }}</strong></p>
              <p class="queue-card__detail queue-card__detail--mb">Tiempo de espera: <strong :class="queue.switch !== false ? 'text-green' : 'text-gray'">{{ queue.waitTime || '0 m' }}</strong></p>
              <!-- Assign button -->
              <div class="queue-card__assign">
                <v-btn
                  @click="queue.typeQueue == 1 ? createTicket() : assignTicketLeft(queue)"
                  :color="queue.switch !== false && queue.pending > 0 ? '#679940' : '#bbb'" dark depressed small rounded
                  :disabled="queue.switch === false || queue.pending <= 0"
                  class="queue-card__assign-btn"
                ><v-icon small left>mdi-login</v-icon>ASIGNAR</v-btn>
              </div>
            </div>
            <!-- Switch + counter -->
            <div class="queue-card__switch">
              <v-switch v-model="queue.switch" @change="closeTicketSwitch(queue)" hide-details dense class="queue-card__switch-input"></v-switch>
              <span class="queue-card__status" :class="queue.switch !== false ? 'queue-card__status--active' : 'queue-card__status--inactive'">{{ queue.switch !== false ? 'Activa' : 'Cerrada' }}</span>
              <span class="queue-card__counter">{{ queue.attended || 0 }}/{{ queue.total || 0 }}</span>
            </div>
          </div>
        </div>
      </v-tab-item>

    </v-tabs-items>

    <!-- Navigation drawer -->
    <v-navigation-drawer
      hide-overlay
      :disable-route-watcher="true"
      :value="showRightMenu"
      absolute
      :clipped="$vuetify.breakpoint.smAndUp"
      width="100%"
      style="height: calc(100vh - 50px); z-index: 100"
      class="elevation-4"
      right
      stateless
    >
      <RightMenuStandDetail v-if="RightMenuStandDetail" />
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import axios from "axios";
import RightMenuStandDetail from "@/components/RightMenuStandDetail.vue";

export default {
  name: "queues",
  components: {
    RightMenuStandDetail
  },
  data: () => ({
    showCreate: true,
    switch1: true,
    tiquetQueue: null,
    components: {},
    deleteDialog: false,
    queuesStatus: [],
    datos: [],
    interVal: null,
    activeTab: null
  }),
  computed: {
    tiquets() {
      return this.TiquetFirst.map(tiquet => {
        const status =
          this.queuesStatus.find(s => s.queue === tiquet.queue) || {};
        const attended =
          this.TiquetAttended.find(a => a.queue === tiquet.queue) || {};
        const ticketsClosed = attended.ticketsClosed || 0;
        const inProgress = tiquet.ticketNow ? 1 : 0;
        const total = ticketsClosed + tiquet.pending + inProgress;

        return {
          ...tiquet,
          switch: status.switch,
          attended: ticketsClosed,
          total: total
        };
      });
    },

    showbutton() {
      let show = true;
      this.TiquetFirst.forEach(element => {
        if (element.ticketNow != null) {
          show = false;
        }
      });
      return show;
    },
    tiquetNumber() {
      console.log(this.TiquetFirst);
      //  console.log(this.actualTicket);

      this.TiquetFirst.forEach(element => {
        if (element.ticketNow != null) {
          this.tiquetQueue = element;
        }
      });
      console.log("tiquet");
      console.log(this.tiquetQueue);

      if (this.tiquetQueue != null) {
        if (this.tiquetQueue.ticketNow == null) {
          return "--";
        } else {
          return this.tiquetQueue.ticketNow.ticket;
          this.showCreate = false;
        }
      } else {
        return "---";
      }
    },
    queueType() {
      this.TiquetFirst.forEach(element => {
        if (element.ticketNow != null) {
          this.tiquetQueue = element;
          this.showCreate = false;
        }
      });
      console.log("type");
      console.log(this.tiquetQueue);

      //  console.log(this.tiquetQueue.typeQueue);
      if (this.tiquetQueue != null) {
        if (this.tiquetQueue.typeQueue != null) {
          return this.tiquetQueue.typeQueue;
        }
      } else {
        return 3;
      }
    },
    queueId() {
      this.TiquetFirst.forEach(element => {
        if (element.ticketNow != null) {
          this.tiquetQueue = element;
          this.showCreate = false;
        }
      });
      console.log("Id");
      console.log(this.tiquetQueue);
      if (this.tiquetQueue != null) {
        if (this.tiquetQueue != null) {
          return this.tiquetQueue.queue;
        }
      }
    },

    // arrQueues(){
    //   let idResource = this.standActions.idResource
    //   let arstands = this.allQueues
    //   let variable = arstands.filter(stand => stand.resources.includes(idResource))
    //   return variable
    // },
    ...mapState("app", ["projectDetail"]),
    ...mapState("queues", [
      "actualTicket",
      "RightMenuStandDetail",
      "showRightMenu",
      "TiquetFirst",
      "TiquetAttended",
      "Tiquet",
      "standActions",
      "allQueues",
      "editedQueue",
      "allResouces"
    ]),
    headers() {
      return [];
    }
  },
  methods: {
    ...mapActions("queues", [
      "assignTicketStoreLeft",
      "rightMenuTrueNewDeviceTableStore4",
      "closeTicketStore",
      "getTicketStore",
      "getTicketAttended",
      "restartQueueStore",
      "deleteTicketStore",
      "createTicketStore",
      "assignTicketStore",
      "assignTicketStore2",
      "cancelnextStore",
      "cancelnextStore2",
      "closeNextStore",
      "closeNextStore2"
    ]),
    ...mapMutations("queues", [
      "cleanTicketFirst",
      "openRightMenuMutation",
      "closeRightMenuMutation"
    ]),

    changePage() {
      this.$store.commit('queues/ActualTicket', []);
      this.$router.push({
        name: "ResumeSpaceMobile"
      });
      this.closeRightMenuMutation();
      this.tiquetQueue = [];
    },

    infoStand() {
      this.openRightMenuMutation();
      this.rightMenuTrueNewDeviceTableStore4();
    },

    async createTicket() {
      let ids = [this.editedQueue.idQueue, this.standActions.idResource];
      this.createTicketStore(ids);
    },

    deleteTicket() {
      let ids = [this.editedQueue.idQueue, this.standActions.idResource];
      this.deleteTicketStore(ids);
    },
    async closeTicketSwitch(queue) { 
      if (queue.switch == false) {
        let ids = [queue.queue, this.standActions.idResource];
        this.closeTicketStore(ids);
      }

      const index = this.queuesStatus.findIndex(t => t.queue === queue.queue);
      if (index !== -1) {
        this.$set(this.queuesStatus, index, { ...this.queuesStatus[index], switch: queue.switch });
      }
    },
    async restartQueue() {
      let ids = [this.editedQueue.idQueue, this.standActions.idResource];
      this.restartQueueStore(ids);
    },
    async assignTicket() {
      let objFinal = {};
      let idsActivas = [];

      this.queuesStatus.forEach(element => {
        if (element.switch == true) {
          idsActivas.push(element.queue);
        }
      });
      objFinal.idsQueues = idsActivas;
      objFinal.idQueueNow = this.queueId;
      objFinal.idResource = this.standActions.idResource;
      objFinal.action = "assign";

      if (objFinal.idQueueNow == undefined) {
        objFinal.idQueueNow = null;
      }
      await this.assignTicketStore2(objFinal);
      if (this.actualTicket.length != 0) {
        this.showCreate = true;
      }
      this.getTicketStore(this.standActions.idResource);
    },
    async closeTicket() {
      let ids = [this.tiquetQueue.queue, this.standActions.idResource];
      await this.closeTicketStore(ids);

      if (this.actualTicket.length != 0) {
        this.showCreate = true;
      }
      await this.getTicketStore(this.standActions.idResource);
      await this.getTicketAttended(this.standActions.idResource);
    },
    async closeAndNextTicket() {
      let objFinal = {};
      let idsActivas = [];

      this.queuesStatus.forEach(element => {
        if (element.switch == true) {
          idsActivas.push(element.queue);
        }
      });
      objFinal.idsQueues = idsActivas;
      objFinal.idQueueNow = this.queueId;
      objFinal.idResource = this.standActions.idResource;
      objFinal.action = "next";

      await this.closeNextStore2(objFinal);
      if (this.actualTicket.length != 0) {
        this.showCreate = true;
      }
      await this.getTicketStore(this.standActions.idResource);
      await this.getTicketAttended(this.standActions.idResource);
    },
    async cancelAndNextTicket() {
      let objFinal = {};
      let idsActivas = [];

      this.queuesStatus.forEach(element => {
        if (element.switch == true) {
          idsActivas.push(element.queue);
        }
      });
      objFinal.idsQueues = idsActivas;
      objFinal.idQueueNow = this.queueId;
      objFinal.idResource = this.standActions.idResource;
      objFinal.action = "cancelnext";

      await this.cancelnextStore2(objFinal);
      if (this.actualTicket.length != 0) {
        this.showCreate = true;
      }
      await this.getTicketStore(this.standActions.idResource);
      await this.getTicketAttended(this.standActions.idResource);
    },

    async assignTicketLeft(queue) {
      let ids = [queue.queue, this.standActions.idResource];
      await this.assignTicketStoreLeft(ids);
      if (this.actualTicket.length != 0) {
        this.showCreate = false;
      }
      await this.getTicketStore(this.standActions.idResource);
      await this.getTicketAttended(this.standActions.idResource);
    },
    restartQueueLeft(queue) {
      let ids = [queue.queue, this.standActions.idResource];
      this.restartQueueStore(ids);
      this.getTicketStore(this.standActions.idResource);
    },

    createStatus() {
      this.TiquetFirst.forEach(element => {
        this.queuesStatus.push(element);
        element.switch = true;
      });
    },
    async checkTickets() {
      this.datos = [...this.TiquetFirst];
      await this.getTicketStore(this.standActions.idResource);
      await this.getTicketAttended(this.standActions.idResource);

      // Efecto verde cuando hay nuevos turnos
      let num = 0;
      this.datos.forEach((element) => {
        if (this.TiquetFirst[num] && this.TiquetFirst[num].pending - element.pending > 0) {
          const elem = document.getElementById(element.queue);
          if (elem) {
            elem.style.backgroundColor = "#c5f272";
            setTimeout(() => {
              if (elem) elem.style.backgroundColor = "#fff";
            }, 2000);
          }
        }
        num++;
      });
    }
  },

  async created() {
    await this.createStatus();
    await this.getTicketAttended(this.standActions.idResource);
    this.interVal = setInterval(this.checkTickets, 5000);
  },
  destroyed() {
    if (this.interVal) {
      clearInterval(this.interVal);
    }
    this.cleanTicketFirst();
  }
};
</script>

<style scoped>
/* ===== Page layout ===== */
.stand-turn-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  background: #f5f5f5;
}
.stand-turn-header {
  background-color: #fff;
  flex-shrink: 0;
  flex-grow: 0;
  min-height: 56px;
}
.stand-turn-header__col {
  display: flex;
  align-items: center;
}
.stand-turn-header__back {
  cursor: pointer;
}
.stand-turn-header__title {
  margin-left: 12px;
  font-size: 18px;
  font-weight: 300;
  color: #777;
  white-space: nowrap;
}
.stand-turn-tab {
  font-size: 12px;
}
>>> .stand-turn-tab-content .v-window__container {
  height: 100%;
  background: transparent !important;
}
>>> .stand-turn-tab-content .v-window-item {
  background: transparent !important;
}
.stand-turn-tab-content {
  flex: 1;
  overflow: auto;
  background: transparent;
}
.stand-turn-tab-item {
  padding: 0;
}
.mobile-tabs {
  flex: 0 0 auto !important;
}

/* ===== Tab 0: Turn panel ===== */
.turn-panel-wrapper {
  position: relative;
  background: #fff;
  min-height: 100%;
  padding-bottom: 80px;
}
.turn-panel {
  max-width: 400px;
  margin: 0 auto;
  text-align: left;
  padding: 16px;
}
.turn-greeting {
  font-size: 14px;
  color: #666;
  margin-bottom: 4px;
}
.turn-queue-name {
  min-height: 30px;
  margin-bottom: 16px;
}
.turn-queue-name__text {
  font-size: 12px;
  color: #888;
  margin: 0;
}
.turn-queue-name__highlight {
  color: #679940;
}
.turn-number-box {
  border-radius: 14px;
  padding: 20px 12px;
  margin-bottom: 14px;
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.turn-number-box--active {
  background: #666;
}
.turn-number-box--empty {
  background: #f0f0f0;
}
.turn-number {
  margin: 0;
  line-height: 1;
  font-size: 80px;
}
.turn-number--active {
  font-weight: 700;
  color: #fff;
  letter-spacing: 4px;
}
.turn-number--empty {
  font-weight: 300;
  color: #ccc;
}
.turn-badge {
  padding: 12px 14px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 14px;
  text-align: center;
}
.turn-badge--open {
  background: #e8f5e0;
  color: #679940;
}
.turn-badge--waiting {
  background: #eee;
  color: #999;
}
.turn-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.turn-actions__row {
  display: flex;
  gap: 10px;
}
.turn-btn {
  font-weight: 700;
  border-radius: 8px;
  min-height: 48px;
}
.turn-btn--primary {
  font-size: 14px;
}
.turn-btn--secondary {
  flex: 1;
  font-size: 13px;
}
.turn-btn--outlined-green {
  font-size: 13px;
  border: 1px solid #679940;
  background: #fff !important;
}
.turn-btn--outlined-gray {
  font-size: 13px;
  border: 1px solid #ccc;
  background: #fff !important;
  color: #777 !important;
}

/* ===== Tab 1: Queue cards ===== */
>>> .queue-tab-item {
  padding: 12px;
  background: #fff;
}
.queue-empty {
  text-align: center;
  padding: 40px 20px;
  background: #f5f5f5;
  border-radius: 8px;
}
.queue-empty__text {
  color: #aaa;
  font-size: 13px;
  margin-top: 10px;
}
.queue-card {
  padding: 14px 12px;
  margin-bottom: 10px;
  border-radius: 12px;
  background: #fff;
  transition: 0.3s;
}
.queue-card--active {
  border: 1px solid #679940;
}
.queue-card--inactive {
  border: 1px solid #e0e0e0;
}
.queue-card__row {
  display: flex;
  align-items: flex-start;
}
.queue-card__icon {
  flex-shrink: 0;
  margin-right: 10px;
  padding-top: 2px;
}
.queue-card__info {
  flex: 1;
  min-width: 0;
}
.queue-card__name {
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 4px;
  text-transform: uppercase;
  text-align: center;
}
.queue-card__name--active {
  color: #679940;
}
.queue-card__name--inactive {
  color: #333;
}
.queue-card__detail {
  font-size: 11px;
  color: #777;
  margin-bottom: 1px;
  text-align: center;
}
.queue-card__detail--mb {
  margin-bottom: 8px;
}
.queue-card__assign {
  text-align: center;
}
.queue-card__assign-btn {
  font-size: 11px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}
.queue-card__switch {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 60px;
  flex-shrink: 0;
}
.queue-card__switch-input {
  margin: 0 !important;
  padding: 0 !important;
}
.queue-card__status {
  font-size: 10px;
  margin-top: 4px;
}
.queue-card__status--active {
  color: #679940;
  font-weight: 600;
}
.queue-card__status--inactive {
  color: #999;
}
.queue-card__counter {
  font-size: 12px;
  color: #999;
  margin-top: 3px;
}
.text-green {
  color: #679940;
}
.text-gray {
  color: #999;
}

h5 {
  font-size: 12px;
  font-weight: 300;
  text-align: initial;
}
h3 {
  text-align: left;
  font-weight: 400;
  font-size: 16px;
  color: #aeaeae;
}
.project-logo {
  position: absolute;
  bottom: 20px;
  right: 20px;
  max-width: 140px;
  max-height: 140px;
  object-fit: contain;
  z-index: 0;
  pointer-events: none;
}
</style>
































// WEBPACK FOOTER //
// src/views/mobile/GeneralStandTurnMobile.vue